import React, { Component } from 'react';
// import SignUpEmailConfirm from './SignUpEmailConfirm.js';
import './basicforms.css';

class SignUpForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleValidate = this.handleValidate.bind(this);
    //this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleChange(event) {
    this.setState({[event.target.name]: event.target.value});
  }

  handleSubmit(event) {

    this.props.auth.signUp({
      username: this.state.email,
      password: this.state.password,
      attributes: {
        email: this.state.email//,          // optional
        //phone_number,   // optional - E.164 number convention
        // other custom attributes
      },
      validationData: []  //optional
    })
    .then(data => {
      console.log(data);
      console.log(data.user);
      console.log(data.userConfirmed);
      this.props.history.push('/emailconfirm/' + this.state.email);
      //this.setState({
      //  email: '',
      //  password: ''
      //});
    })
    .catch(err => {
      console.log(err);
      alert(err.message || JSON.stringify(err));
    });
    event.preventDefault();
  }

  handleValidate(event) {
    if (this.state.email.search('@') > 0) {
      this.props.history.push('/emailconfirm/' + this.state.email);
    } else {
      alert('Please, enter a valid e-mail');
    }
  }

  render() {

    return (
      <div>
    		<form className='basicforms' onSubmit={this.handleSubmit}>
    			<div className='form_container' >
    				<p className='pagetitle'>{this.props.name}</p>
    				<div className="row">
    					<div className="col-25">
    						<label>email</label>
    					</div>
    					<div className="col-50">
    						<input type="email" name="email" value={this.state.email} onChange={this.handleChange} />
    					</div>
    				</div>
    				<div className="row">
    					<div className="col-25">
    						<label>Password</label>
    					</div>
    					<div className="col-50">
    						<input type="password" name="password" value={this.state.password} onChange={this.handleChange} />
    					</div>
    				</div>
            <div className="row">
              <p>A senha deve conter 6 caracteres</p>
            </div>
    				<div className="row">
      				<div className="col-75">
      					<input type="submit" value="Submit"/>
      				</div>
    		    </div>
            <div className="row">
      				<div className="col-75">
      					<input type="button" value="Validate Code / Resend" onClick={this.handleValidate} />
      				</div>
    		    </div>
    			</div>
  		  </form>
      </div>
    );
  }
}

export default SignUpForm;



// WEBPACK FOOTER //
// ./src/components/SignUpForm.js